export interface BankAccountListResponse {
  id: string
  accountName: string
}

export class BankAccountListModel {
  public id: string
  public accountName: string

  public constructor(b: BankAccountListResponse) {
    this.id = b.id
    this.accountName = b.accountName
  }
}
